import React from 'react';

export function ShortcutsCard() {
  return (
    <div className="console-card">
      <div className="panel-header">
        <div>
          <p className="eyebrow">Shortcuts</p>
          <h2>Keyboard cheatsheet</h2>
        </div>
      </div>
      <div className="shortcut-docs">
        <div className="shortcut-row">
          <span>Save file</span>
          <code>Cmd/Ctrl + S</code>
        </div>
        <div className="shortcut-row">
          <span>Format document</span>
          <code>Cmd/Ctrl + Shift + F</code>
        </div>
        <div className="shortcut-row">
          <span>Run tests</span>
          <code>Cmd/Ctrl + Shift + P</code>
        </div>
      </div>
    </div>
  );
}
